import { EmptyState, IllustrationMdEmptyBox } from '@stitch-fix/mode-react';

interface ErrorMessageProps {
  hed: string;
  subhed: string;
  onClick: () => void;
}

const ErrorMessage = ({ hed, subhed, onClick }: ErrorMessageProps) => (
  <EmptyState
    mt={4}
    mx="auto"
    heading={hed}
    image={<IllustrationMdEmptyBox />}
    primaryAction={{
      children: 'Try again',
      onClick,
    }}
  >
    {subhed}
  </EmptyState>
);

export default ErrorMessage;
